window.addEventListener("load", () => {
	if ($('body').hasClass('apply')) {
		//性別で切替
		$('input[name="[powersuit][gender]"]').change(function () {
			const radioVal = $('input[name="[powersuit][gender]"]:checked').val();
			if (radioVal == 'men') {
				$('#product-powersuit-size-set.men').addClass('is-show');
				$('#product-powersuit-size-set.women').removeClass('is-show');
			} else {
				$('#product-powersuit-size-set.men').removeClass('is-show');
				$('#product-powersuit-size-set.women').addClass('is-show');
			}
		});

		//SET内容で切替
		var genderSizeToggle = function () {
			const radioVal = $('input[name="[powersuit][type]"]:checked').val();

			if (radioVal == 'both') {
				//SET
				$('.gender-select').removeClass('is-disable');
				$('.product-powersuit-size-top').removeClass('is-disable');
				$('.product-powersuit-size-bottom').removeClass('is-disable');
				$('.model_wear a.model-btn').removeClass('is-disable');

				$('#carousel-cart-powersuit_set').addClass('is-show');
				$('#carousel-cart-powersuit_top').removeClass('is-show');
				$('#carousel-cart-powersuit_bottom').removeClass('is-show');

			} else if (radioVal == 'top') {
				$('.gender-select').removeClass('is-disable');
				$('.product-powersuit-size-top').removeClass('is-disable');
				$('.product-powersuit-size-bottom').addClass('is-disable');
				$('.model_wear a.model-btn').removeClass('is-disable');

				$('#carousel-cart-powersuit_set').removeClass('is-show');
				$('#carousel-cart-powersuit_top').addClass('is-show');
				$('#carousel-cart-powersuit_bottom').removeClass('is-show');

			} else if (radioVal == 'bottom') {
				$('.gender-select').removeClass('is-disable');
				$('.product-powersuit-size-top').addClass('is-disable');
				$('.product-powersuit-size-bottom').removeClass('is-disable');
				$('.model_wear a.model-btn').removeClass('is-disable');

				$('#carousel-cart-powersuit_set').removeClass('is-show');
				$('#carousel-cart-powersuit_top').removeClass('is-show');
				$('#carousel-cart-powersuit_bottom').addClass('is-show');

			} else if (radioVal == 'none') {
				$('.gender-select').addClass('is-disable');
				$('.product-powersuit-size-top').addClass('is-disable');
				$('.product-powersuit-size-bottom').addClass('is-disable');
				$('.model_wear a.model-btn').addClass('is-disable');

			}
		};
		$('input[name="[powersuit][type]"]').each(genderSizeToggle);
		$('input[name="[powersuit][type]"]').change(genderSizeToggle);

		//The Bike セット内容 選択項目でモーダル変更
		$('input[name="[bike][type]"]').change(function () {
			const radioVal = $(this).val();
			var hrefStr;

			if (radioVal == 'normal' || radioVal == 'new-normal') {
				hrefStr = "javascript:$$.Modal.show('thebike-spec')";

				$('#carousel-cart-bike').addClass('is-show');
				$('#carousel-cart-bike_ex').removeClass('is-show');
				$('#carousel-cart-bike_smart').removeClass('is-show');
				$('#thebike-spec-modalbtn').attr('href', hrefStr);

			} else if (radioVal == 'ex') {
				hrefStr = "javascript:$$.Modal.show('thebike-ex-spec')";

				$('#carousel-cart-bike').removeClass('is-show');
				$('#carousel-cart-bike_ex').addClass('is-show');
				$('#carousel-cart-bike_smart').removeClass('is-show');
				$('#thebike-spec-modalbtn').attr('href', hrefStr);

			} else if (radioVal == 'smart') {
				hrefStr = "javascript:$$.Modal.show('thebike-smart-spec')";

				$('#carousel-cart-bike').removeClass('is-show');
				$('#carousel-cart-bike_ex').removeClass('is-show');
				$('#carousel-cart-bike_smart').addClass('is-show');
				$('#thebike-spec-modalbtn').attr('href', hrefStr);
				
			}

		});

		// The Bike 支払いシュミレーション 選択項目でモーダル変更 
		$('input[name="[bike][type]"]').change(function () {
			const radioVal = $('input[name="[bike][type]"]:checked').val();
			var hrefStr;

			if (radioVal == 'normal') {
				hrefStr = "javascript:$$.Modal.show('simulation-bike')";
				$('#bike-simulation-modalbtn').attr('href', hrefStr);
			} else if (radioVal == 'new-normal') {
				hrefStr = "javascript:$$.Modal.show('simulation-newbike')";
				$('#bike-simulation-modalbtn').attr('href', hrefStr);
			} else if (radioVal == 'ex') {
				hrefStr = "javascript:$$.Modal.show('simulation-bikeex')";
				$('#bike-simulation-modalbtn').attr('href', hrefStr);
			} else if (radioVal == 'smart') {
				hrefStr = "javascript:$$.Modal.show('simulation230908a_sm')";
				$('#bike-simulation-modalbtn').attr('href', hrefStr);
			}
		});

		//Powersuit 選択項目でモーダル変更
		$('input[name="[powersuit][type]"]').change(function () {
			const radioVal = $('input[name="[powersuit][type]"]:checked').val();
			var hrefStr;

			if (radioVal == 'both') {
				hrefStr = "javascript:$$.Modal.show('simulation-powersuit')";
				$('#ps-simulation-modalbtn').attr('href', hrefStr);

			} else if (radioVal == 'top') {
				hrefStr = "javascript:$$.Modal.show('simulation-powersuit-top')";
				$('#ps-simulation-modalbtn').attr('href', hrefStr);

			} else if (radioVal == 'bottom') {
				hrefStr = "javascript:$$.Modal.show('simulation-powersuit-bottom')";
				$('#ps-simulation-modalbtn').attr('href', hrefStr);

			} else if (radioVal == 'corebelt') {
				hrefStr = "javascript:$$.Modal.show('simulation-corebelt')";
				$('#ps-simulation-modalbtn').attr('href', hrefStr);

			} else if (radioVal == 'none') {
				hrefStr = "javascript:$$.Modal.show()";
				$('#ps-simulation-modalbtn').attr('href', hrefStr);
			}
		});

		//シミュレーション CoreBelt
		$('#modal-simulation-corebelt').find('.subscription__simulation__buttons__item').click(function (e) {
			var $target = $('#modal-simulation-corebelt').find('.subscription__simulation__buttons__item');
			$target.removeClass('actived');

			var $this = $(this);
			var index = $target.index(this);
			$this.addClass('actived');

			var $target_results = $('#modal-simulation-corebelt').find('.subscription__simulation__results').find('.subscription__simulation__results__item');
			$target_results.removeClass('actived');
			$target_results.eq(index).addClass('actived');
		});

		//シミュレーション POWERSUIT set
		$('#modal-simulation-powersuit').find('.subscription__simulation__buttons__item').click(function (e) {
			var $target = $('#modal-simulation-powersuit').find('.subscription__simulation__buttons__item');
			$target.removeClass('actived');

			var $this = $(this);
			var index = $target.index(this);
			$this.addClass('actived');

			var $target_results = $('#modal-simulation-powersuit').find('.subscription__simulation__results').find('.subscription__simulation__results__item');
			$target_results.removeClass('actived');
			$target_results.eq(index).addClass('actived');
		});

		//シミュレーション POWERSUIT top
		$('#modal-simulation-powersuit-top').find('.subscription__simulation__buttons__item').click(function (e) {
			var $target = $('#modal-simulation-powersuit-top').find('.subscription__simulation__buttons__item');
			$target.removeClass('actived');

			var $this = $(this);
			var index = $target.index(this);
			$this.addClass('actived');

			var $target_results = $('#modal-simulation-powersuit-top').find('.subscription__simulation__results').find('.subscription__simulation__results__item');
			$target_results.removeClass('actived');
			$target_results.eq(index).addClass('actived');
		});

		//シミュレーション POWERSUIT bottom 
		$('#modal-simulation-powersuit-bottom').find('.subscription__simulation__buttons__item').click(function (e) {
			var $target = $('#modal-simulation-powersuit-bottom').find('.subscription__simulation__buttons__item');
			$target.removeClass('actived');

			var $this = $(this);
			var index = $target.index(this);
			$this.addClass('actived');

			var $target_results = $('#modal-simulation-powersuit-bottom').find('.subscription__simulation__results').find('.subscription__simulation__results__item');
			$target_results.removeClass('actived');
			$target_results.eq(index).addClass('actived');
		});


		//シミュレーション BIKE
		$('#modal-simulation-bike').find('.subscription__simulation__buttons__item').click(function (e) {
			var $target = $('#modal-simulation-bike').find('.subscription__simulation__buttons__item');
			$target.removeClass('actived');

			var $this = $(this);
			var index = $target.index(this);
			$this.addClass('actived');

			var $target_results = $('#modal-simulation-bike').find('.subscription__simulation__results').find('.subscription__simulation__results__item');
			$target_results.removeClass('actived');
			$target_results.eq(index).addClass('actived');
		});

		//シミュレーション BIKE EX
		$('#modal-simulation-bikeex').find('.subscription__simulation__buttons__item').click(function (e) {
			var $target = $('#modal-simulation-bikeex').find('.subscription__simulation__buttons__item');
			$target.removeClass('actived');

			var $this = $(this);
			var index = $target.index(this);
			$this.addClass('actived');

			var $target_results = $('#modal-simulation-bikeex').find('.subscription__simulation__results').find('.subscription__simulation__results__item');
			$target_results.removeClass('actived');
			$target_results.eq(index).addClass('actived');
		});

		//シミュレーション BIKE 15
		$('#modal-simulation-newbike').find('.subscription__simulation__buttons__item').click(function (e) {
			var $target = $('#modal-simulation-newbike').find('.subscription__simulation__buttons__item');
			$target.removeClass('actived');

			var $this = $(this);
			var index = $target.index(this);
			$this.addClass('actived');

			var $target_results = $('#modal-simulation-newbike').find('.subscription__simulation__results').find('.subscription__simulation__results__item');
			$target_results.removeClass('actived');
			$target_results.eq(index).addClass('actived');
		});

		//シミュレーション campaign BIKE 13
		$('#modal-simulation-set2302').find('.subscription__simulation__buttons__item').click(function (e) {
			var $target = $('#modal-simulation-set2302').find('.subscription__simulation__buttons__item');
			$target.removeClass('actived');

			var $this = $(this);
			var index = $target.index(this);
			$this.addClass('actived');

			var $target_results = $('#modal-simulation-set2302').find('.subscription__simulation__results').find('.subscription__simulation__results__item');
			$target_results.removeClass('actived');
			$target_results.eq(index).addClass('actived');
		});

		//シミュレーション BIKE Smart
		$('#modal-simulation-bikesmart').find('.subscription__simulation__buttons__item').click(function (e) {
			var $target = $('#modal-simulation-bikesmart').find('.subscription__simulation__buttons__item');
			$target.removeClass('actived');

			var $this = $(this);
			var index = $target.index(this);
			$this.addClass('actived');

			var $target_results = $('#modal-simulation-bikesmart').find('.subscription__simulation__results').find('.subscription__simulation__results__item');
			$target_results.removeClass('actived');
			$target_results.eq(index).addClass('actived');
		});

		//シミュレーション CP 50%OFF EX
		$('#modal-simulation230908a_ex').find('.subscription__simulation__buttons__item').click(function (e) {
			var $target = $('#modal-simulation230908a_ex').find('.subscription__simulation__buttons__item');
			$target.removeClass('actived');

			var $this = $(this);
			var index = $target.index(this);
			$this.addClass('actived');

			var $target_results = $('#modal-simulation230908a_ex').find('.subscription__simulation__results').find('.subscription__simulation__results__item');
			$target_results.removeClass('actived');
			$target_results.eq(index).addClass('actived');
		});
		//シミュレーション CP 20%OFF Smart
		$('#modal-simulation230908a_bk').find('.subscription__simulation__buttons__item').click(function (e) {
			var $target = $('#modal-simulation230908a_bk').find('.subscription__simulation__buttons__item');
			$target.removeClass('actived');

			var $this = $(this);
			var index = $target.index(this);
			$this.addClass('actived');

			var $target_results = $('#modal-simulation230908a_bk').find('.subscription__simulation__results').find('.subscription__simulation__results__item');
			$target_results.removeClass('actived');
			$target_results.eq(index).addClass('actived');
		});

		//シミュレーション CP 20%OFF Smart
		$('#modal-simulation230908a_sm').find('.subscription__simulation__buttons__item').click(function (e) {
			var $target = $('#modal-simulation230908a_sm').find('.subscription__simulation__buttons__item');
			$target.removeClass('actived');

			var $this = $(this);
			var index = $target.index(this);
			$this.addClass('actived');

			var $target_results = $('#modal-simulation230908a_sm').find('.subscription__simulation__results').find('.subscription__simulation__results__item');
			$target_results.removeClass('actived');
			$target_results.eq(index).addClass('actived');
		});

		var colorSizeSelectShowHide = function () {
			var $this = $(this);
			var $target = $($this.data('colorsizeselecttarget'));
			$target.parent().find('.colorSizeSelectShowHideArea').removeClass('is-show');
			$target.addClass('is-show');
			if(typeof modelCarousel.swiper !== 'undefined') {
				modelCarousel.swiper.update();
			}
		};
		$('[data-colorsizeselecttarget]:checked').each(colorSizeSelectShowHide);
		$('[data-colorsizeselecttarget]').on('click', colorSizeSelectShowHide);
	};
});

$(function () {
	if ($('.sec-product .block-product .radio-set input[type=radio]').length) {
		var bikeTypeChange = function () {
			if ($("#bike-type01").is(':checked')) {
				$('.sec-product .block-product .sec-installation').addClass('is-show');
				$('.sec-product .block-product .for-bike-type03').removeClass('is-show');
				$('.sec-product .block-product .for-bike-type02').removeClass('is-show');
				$('.sec-product .block-product .for-bike-type01').addClass('is-show');
				$('.sec-product .block-product .notfor-ex').removeClass('is-hidden');
			}
			if ($("#bike-type02").is(':checked')) {
				$('.sec-product .block-product .sec-installation').addClass('is-show');
				$('.sec-product .block-product .for-bike-type03').removeClass('is-show');
				$('.sec-product .block-product .for-bike-type02').addClass('is-show');
				$('.sec-product .block-product .for-bike-type01').removeClass('is-show');
				$('.sec-product .block-product .notfor-ex').addClass('is-hidden');
			}
			if ($("#bike-type03").is(':checked')) {
				$('.sec-product .block-product .sec-installation').removeClass('is-show');
				$('.sec-product .block-product .notfor-ex').removeClass('is-hidden');
			}
			if ($("#bike-type04").is(':checked')) {
				$('.sec-product .block-product .sec-installation').addClass('is-show');
				$('.sec-product .block-product .for-bike-type03').removeClass('is-show');
				$('.sec-product .block-product .for-bike-type02').removeClass('is-show');
				$('.sec-product .block-product .for-bike-type01').addClass('is-show');
				$('.sec-product .block-product .notfor-ex').removeClass('is-hidden');
			}
			if ($("#bike-type05").is(':checked')) {
				$('.sec-product .block-product .sec-installation').addClass('is-show');
				$('.sec-product .block-product .for-bike-type03').addClass('is-show');
				$('.sec-product .block-product .for-bike-type02').removeClass('is-show');
				$('.sec-product .block-product .for-bike-type01').removeClass('is-show');
				$('.sec-product .block-product .notfor-ex').removeClass('is-hidden');
			}
		};
		$("input[name='[bike][type]']").change(bikeTypeChange);
		$(window).on('load', bikeTypeChange);
	}

	if (location.hash) {
		if (location.hash == '#sizeguide') {
			javascript: $$.Modal.show('sizeguide');
		}
	}
	$('.modal-close').click(function () {
		if (location.hash == '#sizeguide') {
			window.location.href = '/subscription';
		}
	})
});
import '../subscription_common.js';
import '../change_size_by_color.js';
import '../size_selection.js';
